import { useEffect, useState } from "react";
import api from "@/lib/api";
import { WhatsappLogo } from "@phosphor-icons/react";

/**
 * Click-to-chat WhatsApp button. Uses the business WhatsApp number configured
 * via WHATSAPP_NUMBER on the backend, exposed at GET /api/public-settings.
 *
 * Props:
 *   - message: optional prefilled text
 *   - label: button label (default "WhatsApp")
 *   - variant: "button" (default) or "inline"
 *   - testId
 */
export default function WhatsappButton({ message = "", label = "WhatsApp", variant = "button", testId = "whatsapp-button" }) {
  const [number, setNumber] = useState("");
  useEffect(() => {
    api.get("/public-settings").then((r) => setNumber(r.data.whatsapp_number || "")).catch(() => {});
  }, []);
  if (!number) return null;
  const href = `https://wa.me/${number}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
  if (variant === "inline") {
    return (
      <a href={href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-emerald-700 hover:text-emerald-800 text-sm font-semibold" data-testid={testId}>
        <WhatsappLogo size={16} weight="fill" /> {label}
      </a>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-1 h-8 px-3 text-xs uppercase tracking-widest border border-emerald-300 text-emerald-700 hover:bg-emerald-50 rounded-md transition-colors"
      data-testid={testId}
    >
      <WhatsappLogo size={14} weight="fill" className="mr-0.5" />
      {label}
    </a>
  );
}
